import { OnboardingImage } from './OnboardingImage';

const OnboardingResourcesImage = ({ style }) => {
  const twoX = {
    es: require('./es/onboarding-resources@2x.jpg'),
    fr: require('./fr/onboarding-resources@2x.jpg'),
    en: require('./onboarding-resources@2x.jpg')
  };
  const threeX = {
    es: require('./es/onboarding-resources@3x.jpg'),
    fr: require('./fr/onboarding-resources@3x.jpg'),
    en: require('./onboarding-resources@3x.jpg')
  };
  return <OnboardingImage twoX={twoX} threeX={threeX} style={style} />;
};

export { OnboardingResourcesImage };
